<template>
  <div class="header-top">
    <div class="left">
      <img src="@/assets/logo.png" alt="Logo" class="logo" />
      <span class="app-name">数智横水农技讲堂</span>
    </div>
    <div class="right">
      <div class="user-info" @click="toggleDropdown">
        <!-- <img :src="user.avatar" alt="用户头像" class="avatar" /> -->
        <img src="@/assets/avatar.png" alt="用户头像" class="avatar" />
        <span class="username">{{ user.name }}</span>
      </div>
      <UserDropdown :isOpen="isDropdownOpen" :user="user" @logout="logout" />
    </div>
  </div>
</template>

<script>
import UserDropdown from './UserDropdown.vue';
import store from "@/store";

export default {
  name: 'HeaderTop',
  components: {
    UserDropdown,
  },
  data() {
    return {
      isDropdownOpen: false,
      user: {
        // avatar: require('avatar.png'),
        name: '张三',
      },
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    logout() {
      this.isDropdownOpen = false;

      localStorage.clear();
			store.dispatch("logout");
			this.$router.push({ path: "/" });
    },
  },
};
</script>

<style scoped>
.header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: #333;
  color: white;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.left {
  display: flex;
  align-items: center;
}

.logo {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.app-name {
  font-size: 18px;
  font-weight: bold;
}

.right {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;
}

.username {
  font-size: 16px;
}
</style>
